import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <section {...{
      "className": "section-lead"
    }}><p parentName="section">{`The `}<inlineCode parentName="p">{`shippingRateInput`}</inlineCode>{` is used as an input to select a `}<a parentName="p" {...{
          "href": "/api/../api/projects/shippingMethods#shippingratepricetier"
        }}>{`ShippingRatePriceTier`}</a>{`. If no matching tier can be found, or the input is not set, the default price is used.`}</p>
      <ul parentName="section">
        <li parentName="ul"><inlineCode parentName="li">{`action`}</inlineCode>{` - String - `}<inlineCode parentName="li">{`"setShippingRateInput"`}</inlineCode></li>
        <li parentName="ul"><inlineCode parentName="li">{`shippingRateInput`}</inlineCode>{` - `}<a parentName="li" {...{
            "href": "/api/../api/projects/carts#shippingrateinputdraft"
          }}>{`ShippingRateInputDraft`}</a>{` - Optional`}<br parentName="li"></br>
          {`Based on the definition of `}<a parentName="li" {...{
            "href": "/api/../api/projects/project#shippingrateinputtype"
          }}>{`ShippingRateInputType`}</a>{`. If `}<a parentName="li" {...{
            "href": "/api/../api/projects/project#cartclassificationtype"
          }}>{`CartClassification`}</a>{` is defined, it must be `}<a parentName="li" {...{
            "href": "/api/../api/projects/carts#classificationshippingrateinput"
          }}>{`ClassificationShippingRateInput`}</a>{`. If `}<a parentName="li" {...{
            "href": "/api/../api/projects/project#cartscoretype"
          }}>{`CartScore`}</a>{` is defined, it must be `}<a parentName="li" {...{
            "href": "/api/../api/projects/carts#scoreshippingrateinput"
          }}>{`ScoreShippingRateInput`}</a>{`. Otherwise it can not bet set.`}</li>
      </ul>
    </section>
    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      